import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '@app/core/services/auth-guard.service';
import { LoginComponent } from './login/login.component';
import { AuthComponent } from './auth.component';

const routes: Routes = [

  {
        path: '',
        component: AuthComponent,
        children: [
             { path: '', redirectTo:'login', pathMatch:'full'},
             { path: 'login', component: LoginComponent, pathMatch: 'full' },
             { path: 'logout', component: LoginComponent, pathMatch: 'full' },
        ]
    }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/auth/auth-routing.module.ts